// src/quiz/pgcet-mca-test/pgcetmcaMocks.js
// PGCET MCA mocks. Every mock follows PgcetmcaConfig (same sections, question
// ids 1–100); only the questions differ. Results save under the same test
// name with `result.mock`, which the profile uses to tell mocks apart.
// Publishing a new mock only means adding it here.
import PGCET_CONFIG from "./PgcetmcaConfig";
import mathematics1 from "./PgcetmcaMathematics";
import computerAwareness1 from "./PgcetmcaComputerAwareness";
import analyticalReasoning1 from "./PgcetmcaAnalyticalReasoning";
import generalAwareness1 from "./PgcetmcaGeneralAwareness";
import generalEnglish1 from "./PgcetmcaGeneralEnglish";
import mathematics2 from "./mock2/PgcetmcaMathematics";
import computerAwareness2 from "./mock2/PgcetmcaComputerAwareness";
import analyticalReasoning2 from "./mock2/PgcetmcaAnalyticalReasoning";
import generalAwareness2 from "./mock2/PgcetmcaGeneralAwareness";
import generalEnglish2 from "./mock2/PgcetmcaGeneralEnglish";
import mathematics3 from "./mock3/PgcetmcaMathematics";
import computerAwareness3 from "./mock3/PgcetmcaComputerAwareness";
import analyticalReasoning3 from "./mock3/PgcetmcaAnalyticalReasoning";
import generalAwareness3 from "./mock3/PgcetmcaGeneralAwareness";
import generalEnglish3 from "./mock3/PgcetmcaGeneralEnglish";
import mathematics4 from "./mock4/PgcetmcaMathematics";
import computerAwareness4 from "./mock4/PgcetmcaComputerAwareness";
import analyticalReasoning4 from "./mock4/PgcetmcaAnalyticalReasoning";
import generalAwareness4 from "./mock4/PgcetmcaGeneralAwareness";
import generalEnglish4 from "./mock4/PgcetmcaGeneralEnglish";
import mathematics5 from "./mock5/PgcetmcaMathematics";
import computerAwareness5 from "./mock5/PgcetmcaComputerAwareness";
import analyticalReasoning5 from "./mock5/PgcetmcaAnalyticalReasoning";
import generalAwareness5 from "./mock5/PgcetmcaGeneralAwareness";
import generalEnglish5 from "./mock5/PgcetmcaGeneralEnglish";
import mathematics6 from "./mock6/PgcetmcaMathematics";
import computerAwareness6 from "./mock6/PgcetmcaComputerAwareness";
import analyticalReasoning6 from "./mock6/PgcetmcaAnalyticalReasoning";
import generalAwareness6 from "./mock6/PgcetmcaGeneralAwareness";
import generalEnglish6 from "./mock6/PgcetmcaGeneralEnglish";
import mathematics7 from "./mock7/PgcetmcaMathematics";
import computerAwareness7 from "./mock7/PgcetmcaComputerAwareness";
import analyticalReasoning7 from "./mock7/PgcetmcaAnalyticalReasoning";
import generalAwareness7 from "./mock7/PgcetmcaGeneralAwareness";
import generalEnglish7 from "./mock7/PgcetmcaGeneralEnglish";
import mathematics8 from "./mock8/PgcetmcaMathematics";
import computerAwareness8 from "./mock8/PgcetmcaComputerAwareness";
import analyticalReasoning8 from "./mock8/PgcetmcaAnalyticalReasoning";
import generalAwareness8 from "./mock8/PgcetmcaGeneralAwareness";
import generalEnglish8 from "./mock8/PgcetmcaGeneralEnglish";
import mathematics9 from "./mock9/PgcetmcaMathematics";
import computerAwareness9 from "./mock9/PgcetmcaComputerAwareness";
import analyticalReasoning9 from "./mock9/PgcetmcaAnalyticalReasoning";
import generalAwareness9 from "./mock9/PgcetmcaGeneralAwareness";
import generalEnglish9 from "./mock9/PgcetmcaGeneralEnglish";

const QUESTION_SETS = {
  1: {
    mathematics: mathematics1,
    computerAwareness: computerAwareness1,
    analyticalReasoning: analyticalReasoning1,
    generalAwareness: generalAwareness1,
    generalEnglish: generalEnglish1,
  },
  2: {
    mathematics: mathematics2,
    computerAwareness: computerAwareness2,
    analyticalReasoning: analyticalReasoning2,
    generalAwareness: generalAwareness2,
    generalEnglish: generalEnglish2,
  },
  3: {
    mathematics: mathematics3,
    computerAwareness: computerAwareness3,
    analyticalReasoning: analyticalReasoning3,
    generalAwareness: generalAwareness3,
    generalEnglish: generalEnglish3,
  },
  4: {
    mathematics: mathematics4,
    computerAwareness: computerAwareness4,
    analyticalReasoning: analyticalReasoning4,
    generalAwareness: generalAwareness4,
    generalEnglish: generalEnglish4,
  },
  5: {
    mathematics: mathematics5,
    computerAwareness: computerAwareness5,
    analyticalReasoning: analyticalReasoning5,
    generalAwareness: generalAwareness5,
    generalEnglish: generalEnglish5,
  },
  6: {
    mathematics: mathematics6,
    computerAwareness: computerAwareness6,
    analyticalReasoning: analyticalReasoning6,
    generalAwareness: generalAwareness6,
    generalEnglish: generalEnglish6,
  },
  7: {
    mathematics: mathematics7,
    computerAwareness: computerAwareness7,
    analyticalReasoning: analyticalReasoning7,
    generalAwareness: generalAwareness7,
    generalEnglish: generalEnglish7,
  },
  8: {
    mathematics: mathematics8,
    computerAwareness: computerAwareness8,
    analyticalReasoning: analyticalReasoning8,
    generalAwareness: generalAwareness8,
    generalEnglish: generalEnglish8,
  },
  9: {
    mathematics: mathematics9,
    computerAwareness: computerAwareness9,
    analyticalReasoning: analyticalReasoning9,
    generalAwareness: generalAwareness9,
    generalEnglish: generalEnglish9,
  },
};

export const PGCET_MCA_MOCK_NUMBERS = Object.keys(QUESTION_SETS).map(Number);

export const getPgcetMcaSections = (mock = 1) =>
  PGCET_CONFIG.sections.map((s) => ({ ...s, questions: (QUESTION_SETS[mock] || QUESTION_SETS[1])[s.key] || [] }));

export const getPgcetMcaQuestions = (mock = 1) => getPgcetMcaSections(mock).flatMap((s) => s.questions);

// Mock 1 keeps its original routes.
export const pgcetMcaPath = (mock = 1, page = "") =>
  `/quiz/pgcet${mock > 1 ? `/mock${mock}` : ""}${page ? `/${page}` : ""}`;

export const pgcetMcaTitle = (mock = 1) => `${PGCET_CONFIG.title}${mock > 1 ? ` — Mock ${mock}` : ""}`;
